export function hasWidth(el: HTMLElement) {
  return el.clientWidth > 0;
}
